(() => {
  const desktopHover = window.matchMedia(['(min-width: 990px)', '(hover: hover)', '(pointer: fine)'].join(' and '));
  const menu = document.querySelector('.header__inline-menu');
  const reflectExpansion = (element, expanded) => element.setAttribute('aria-expanded', String(expanded));

  if (!menu) return;

  menu.querySelectorAll('header-menu > details').forEach((panel) => {
    const trigger = panel.querySelector(':scope > summary');
    let closingTimer;

    if (!trigger) return;

    const reveal = () => {
      if (desktopHover.matches === false) return;

      window.clearTimeout(closingTimer);

      menu.querySelectorAll('header-menu > details[open]').forEach((openPanel) => {
        if (openPanel === panel) return;
        const openTrigger = openPanel.firstElementChild;
        openPanel.removeAttribute('open');
        if (openTrigger) reflectExpansion(openTrigger, false);
      });

      panel.setAttribute('open', '');
      reflectExpansion(trigger, true);
    };

    const conceal = () => {
      if (desktopHover.matches === false) return;

      window.clearTimeout(closingTimer);
      closingTimer = window.setTimeout(() => {
        if (panel.matches(':hover') || panel.contains(document.activeElement)) return;
        panel.removeAttribute('open');
        reflectExpansion(trigger, false);
      }, 120);
    };

    panel.addEventListener('pointerenter', reveal);
    panel.addEventListener('pointerleave', conceal);
    panel.addEventListener('pointercancel', conceal);
  });
})();
